// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"81":"f499e418","86":"385e6567","384":"8d1a0aad","829":"385e6567"}[chunkId] + ".chunk.css";
};